import React, { Component } from "react";

import { IimageSlideComponentProps } from "../types/props";
import { EchallengeImages, EDirection } from "../enums";
import { CHALLENGE_IMAGE_PREFIX, IMAGE_CONFIG, TITLE_CONFIG } from "../config";
import closeImage from "../../assets/close.svg";
import ReactTooltip from "react-tooltip";
import "./imageSlide.component.scss";
class ImageSlideComponent extends Component<IimageSlideComponentProps> {
  render() {
    return (
      <div className="image-slide">
        <ReactTooltip backgroundColor="rgb(0, 51, 89)" />
        <div className="image-slide--left">
          <div className="image-slide--buttons">
            <button
              className="image-slide--up"
              disabled={this.props.index === 0}
              onClick={this.up}
            >
              <span className="sr-only">Move Up</span>
            </button>
            <button
              className="image-slide--down"
              disabled={this.props.last}
              onClick={this.down}
            >
              <span className="sr-only">Move Down</span>
            </button>
            <span className="image-slide--index">{this.props.index + 1}</span>
          </div>
        </div>
        <div className="image-slide--right">
          <button className="image-slide--remove" onClick={this.remove}>
            <img src={`/dist/${closeImage}`} />
            <span className="sr-only">Remove</span>
          </button>
          <h2 data-tip={this.getTitle().length > 30 ? this.getTitle() : null}>
            {this.getTitle()}
          </h2>
          <img src={this.getImage()} />
        </div>
      </div>
    );
  }

  up = () => {
    this.props.moveSlide(this.props.index, EDirection.up);
  };
  down = () => {
    this.props.moveSlide(this.props.index, EDirection.down);
  };
  remove = () => {
    this.props.removeSlide(this.props.index);
  };
  getTitle = () => {
    const config = TITLE_CONFIG[this.props.challenge];
    if (config === undefined) {
      return `Not Configured`;
    } else return config;
  };
  getImage = () => {
    const config = IMAGE_CONFIG[this.props.challenge];
    if (config === undefined) {
      return `${CHALLENGE_IMAGE_PREFIX}fake_placeholder.png`;
    } else if (config === EchallengeImages.screenCapture) {
      return this.props.image;
    } else {
      return `${CHALLENGE_IMAGE_PREFIX}${config}`;
    }
  };
}

export default ImageSlideComponent;
